import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useState } from "react";

export const PROGRAM_INFO_YEAR_2025 = "2025";
export const PROGRAM_INFO_YEAR_2026 = "2026";

const PROGRAM_INFO_STORAGE_KEY = "laeProgramInfoYear";
const DEFAULT_PROGRAM_INFO_YEAR = PROGRAM_INFO_YEAR_2026;
const PROGRAM_INFO_YEARS = [PROGRAM_INFO_YEAR_2025, PROGRAM_INFO_YEAR_2026];

const isValidProgramInfoYear = (year) => PROGRAM_INFO_YEARS.includes(year);

const getInitialProgramInfoYear = () => {
  if (typeof window === "undefined") {
    return DEFAULT_PROGRAM_INFO_YEAR;
  }

  const storedYear = window.localStorage.getItem(PROGRAM_INFO_STORAGE_KEY);
  return isValidProgramInfoYear(storedYear)
    ? storedYear
    : DEFAULT_PROGRAM_INFO_YEAR;
};

export const useProgramInfoYear = () => {
  const [programInfoYear, setProgramInfoYearState] = useState(
    getInitialProgramInfoYear,
  );

  const setProgramInfoYear = (nextYear) => {
    if (!isValidProgramInfoYear(nextYear)) {
      return;
    }

    setProgramInfoYearState(nextYear);

    if (typeof window !== "undefined") {
      window.localStorage.setItem(PROGRAM_INFO_STORAGE_KEY, nextYear);
    }
  };

  return {
    programInfoYear,
    isProgramInfo2026: programInfoYear === PROGRAM_INFO_YEAR_2026,
    setProgramInfoYear,
  };
};

export const ProgramInfoYearSwitch = ({ value, onChange }) => {
  const handleChange = (_, nextYear) => {
    if (nextYear) {
      onChange(nextYear);
    }
  };

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      color="primary"
      value={value}
      onChange={handleChange}
      aria-label="Επιλογή έτους πληροφοριών προγράμματος"
    >
      <ToggleButton
        value={PROGRAM_INFO_YEAR_2026}
        aria-label="Πληροφορίες προγράμματος 2026"
      >
        2026
      </ToggleButton>
      <ToggleButton
        value={PROGRAM_INFO_YEAR_2025}
        aria-label="Πληροφορίες προγράμματος 2025"
      >
        2025
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export const LandingProgramInfo2026 = ({ yearSwitch } = {}) => (
  <>
    <div
      style={{
        alignItems: "center",
        display: "flex",
        flexWrap: "wrap",
        gap: "1rem",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <h2 className="landing-subtitle">
        Παροχή Χρηματικών Βραβείων - Υποτροφίες
        <br /> σε επιτυχόντες/ούσες μαθητές/τριες στις πανελλαδικές εξετάσεις
        <br />
        για πρώτη φορά το έτος 2026, σε δημόσια Ανώτατα Εκπαιδευτικά Ιδρύματα
        της ημεδαπής, δικαιούχους του ΛΑΕ, με άμεσο ή έμμεσο δικαίωμα <br />
      </h2>
      {yearSwitch}
    </div>

    <h3 className="landing-description">
      <br />
      <p>
        Καλωσορίσατε στην ψηφιακή πλατφόρμα υποβολής αιτήσεων για τη{" "}
        <strong> χορήγηση Χρηματικών Βραβείων</strong>{" "}
      </p>
      <br />
      <p>
        <strong>
          Σημειώνεται ότι στη φετινή περίοδο δικαιούχοι της παροχής Χρηματικών
          Βραβείων - Υποτροφίες είναι οι επιτυχόντες/ούσες μαθητές/τριες στις
          πανελλαδικές εξετάσεις για πρώτη φορά το έτος 2026 (ή με άλλη
          διαδικασία που εξομοιώνεται με αυτες σε δημόσια Α.Ε.Ι. της ημεδαπής,
          ωφελούμενοι του ΛΑΕ με άμεσο ή έμμεσο δικαίωμα).
        </strong>
      </p>
      <br />
      <p>
        {" "}
        Η πλατφόρμα παρέχει έναν φιλικό και ασφαλή τρόπο για την ηλεκτρονική
        υποβολή της απαιτούμενης αίτησης, με άντληση δικαιολογητικών και
        διασταύρωση στοιχείων μέσω υπηρεσιών διαλειτουργικότητας με βάσεις
        δεδομένων άλλων δημόσιων φορέων και υπηρεσιών σε πραγματικό χρόνο και αν
        αυτό δεν επιτευχθεί, παρέχεται η δυνατότητα επισύναψης των απαιτούμενων
        πιστοποιητικών και δικαιολογητικών, σύμφωνα με τις ισχύουσες διατάξεις
        της σχετικής Υπουργικής Απόφασης.
      </p>
      <br />
      <p>
        {" "}
        Οι δικαιούχοι έχουν τη δυνατότητα να ενημερωθούν για τις
        <strong> προϋποθέσεις συμμετοχής</strong>, να δημιουργήσουν μία{" "}
        <strong>νέα αίτηση</strong>, την οποία μπορούν να υποβάλουν και να
        παρακολουθούν την <strong>πορεία ελέγχου</strong> και εκκαθάρισής της,
        λαμβάνοντας <strong> έγκαιρες ειδοποιήσεις</strong> για τυχόν πρόσθετες
        ενέργειες στις οποίες απαιτείται να προβούν.
      </p>
      <br />
      <p>
        <text style={{ fontSize: "1.25rem" }}>
          <strong>
            Οι αιτήσεις για τη χορήγηση της παροχής χρηματικών βραβείων -
            υποτροφίες υποβάλλονται αποκλειστικά ηλεκτρονικά
          </strong>
          , μέσω της παρούσας ψηφιακής πλατφόρμας, χρησιμοποιώντας τα στοιχεία
          ταυτοποίησης (κωδικοί) taxisnet ακολουθώντας τον σύνδεσμο{" "}
          <strong>«Είσοδος για πολίτες»</strong>.
        </text>
      </p>
    </h3>
  </>
);

export const LandingProgramInfo2025 = ({ yearSwitch } = {}) => (
  <>
    <div
      style={{
        alignItems: "center",
        display: "flex",
        flexWrap: "wrap",
        gap: "1rem",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <h2 className="landing-subtitle">
        Παροχή Χρηματικών Βοηθημάτων σε Δικαιούχους ΛΑΕ/ΟΠΕΚΑ
      </h2>
      {yearSwitch}
    </div>

    <h3 className="landing-description">
      <ul>
        <li>
          <strong>Μητέρες (Τρίτεκνες / Πολύτεκνες)</strong>
        </li>
        <li>
          <strong>
            Υποτροφίες Επιτυχόντων τέκνων τους στις Πανελλαδικές Εξετάσεις
          </strong>
        </li>
      </ul>

      <p>
        Καλωσορίσατε στην ψηφιακή πλατφόρμα υποβολής αιτήσεων για τη
        <strong>
          {" "}
          χορήγηση χρηματικού βοηθήματος σε τρίτεκνες και πολύτεκνες μητέρες
        </strong>{" "}
        και{" "}
        <strong>τα επιτυχόντα στις Πανελλαδικές Εξετάσεις τέκνα τους</strong>,
        στο πλαίσιο του Προγράμματος Κοινωνικού Χαρακτήρα του Λογαριασμού
        Αγροτικής Εστίας (ΛΑΕ) του ΟΠΕΚΑ.
      </p>
      <br />
      <p>
        {" "}
        Η πλατφόρμα παρέχει έναν φιλικό και ασφαλή τρόπο για την πλήρη
        ηλεκτρονική υποβολή αίτησης, με δυνατότητα αυτόματης άντλησης
        δικαιολογητικών και διασταύρωσης στοιχείων, σύμφωνα με τις προδιαγραφές
        του προγράμματος και τις διατάξεις της σχετικής Κοινής Υπουργικής
        Απόφασης.
      </p>
      <br />
      <p>
        {" "}
        Οι δικαιούχοι μητέρες μπορούν εύκολα να ενημερωθούν για τις προϋποθέσεις
        συμμετοχής, να ξεκινήσουν νέα αίτηση, να υποβάλουν και να παρακολουθούν
        την πορεία της λαμβάνοντας έγκαιρες ειδοποιήσεις για οποιαδήποτε
        ενέργεια απαιτείται.
      </p>
      <br />
      <p>
        <text style={{ fontSize: "1.25rem" }}>
          <strong>
            Οι αιτήσεις για συμμετοχή στα προγράμματα παροχής χρηματικών
            βοηθημάτων υποβάλλονται πλέον ηλεκτρονικά
          </strong>
          , ακολουθώντας τους παρακάτω συνδέσμους ανάλογα με το αν είστε{" "}
          <strong>
            (α) πολίτης που επιθυμεί να υποβάλει ηλεκτρονικά ή/και να ελέγξει
            την πορεία της αίτησής του
          </strong>
          , ή (β) υπάλληλος / εξουσιοδοτημένος χρήστης του ΟΠΕΚΑ.
        </text>
      </p>
    </h3>
  </>
);

export const LoginProgramInfo2026 = ({ legalFiles } = {}) => (
  <>
    <p>
      Ο ΛΑΕ/ΟΠΕΚΑ χορηγεί και χρηματικά βοηθήματα – βραβεία σε{" "}
      <strong>τρίτεκνες και πολύτεκνες μητέρες</strong>, συνταξιούχους ή
      ασφαλισμένες του e-ΕΦΚΑ (ΟΓΑ), καθώς και σε{" "}
      <strong>μονογονείς πατέρες</strong>, με τις ίδιες προϋποθέσεις.
    </p>

    <p>
      Δικαιούχοι της παροχής είναι{" "}
      <strong>
        εξακόσιες (600) πολύτεκνες και δύο χιλιάδες τριακόσιες (2.300) τρίτεκνες
        μητέρες
      </strong>
      , ή αντίστοιχα <strong>μονογονείς πατέρες</strong>.
    </p>
    <p>
      Οι μητέρες, καθώς και οι μονογονείς πατέρες πρέπει να είναι{" "}
      <strong>δικαιούχοι περίθαλψης με ενεργή ασφαλιστική ικανότητα</strong> και
      ειδικότερα{" "}
      <strong>
        τα τέκνα με δικαίωμα περίθαλψης το οποίο να απορρέει από δικαιούχο του
        ΛΑΕ/ΟΠΕΚΑ
      </strong>
      .
    </p>
    <p>
      Για τις ανάγκες του προγράμματος,{" "}
      <strong>μονογονέας ορίζεται ο πατέρας</strong> που ασκεί κατ’
      αποκλειστικότητα εν τοις πράγμασι ή μετά από σχετική ανάθεση με δικαστική
      απόφαση, συμβολαιογραφική πράξη ή πρακτικό διαμεσολάβησης, σύμφωνα με την
      κείμενη νομοθεσία, την προσωρινή ή μόνιμη επιμέλεια των τέκνων που
      λαμβάνονται υπόψη, σύμφωνα με τα οριζόμενα στο επόμενο εδάφιο, όντας
      άγαμος, σε χηρεία ή διαζευγμένος ή σε διάσταση, ή λόγω κράτησης του ετέρου
      γονέα σε σωφρονιστικό κατάστημα.
    </p>
    <p>
      <p>
        Σε περίπτωση που εκδηλωθεί <strong>ενδιαφέρον</strong> από αριθμό
        δικαιούχων <strong>πέραν του καθορισμένου για κάθε κατηγορία</strong>, η
        επιλογή γίνεται με <strong>κλήρωση</strong>, η οποία διεξάγεται με
        διαδικασία που ορίζεται με απόφαση του Δ.Σ. του ΟΠΕΚΑ.
      </p>
    </p>

    <p>
      <strong>Προϋποθέσεις: </strong>
      Δικαίωμα συμμετοχής στο πρόγραμμα Παροχής χρηματικών βοηθημάτων – βραβείων
      δικαιούνται <strong>τρίτεκνες και πολύτεκνες</strong> μητέρες, ή{" "}
      <strong>μονογονείς πατέρες</strong> αντίστοιχα, εφόσον:
    </p>
    <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
      <li style={{ fontSize: "1.05rem", marginBottom: "12px" }}>
        Είναι ασφαλισμένες/οι του e-ΕΦΚΑ (ΟΓΑ) και ασφαλιστικά ενήμερες/οι κατά
        την <strong>31η Δεκεμβρίου 2025</strong>, ή
      </li>
      <li style={{ fontSize: "1.05rem", marginBottom: "12px" }}>
        Είναι συνταξιούχοι του e-ΕΦΚΑ (ΟΓΑ), ή
      </li>
      <li style={{ fontSize: "1.05rem", marginBottom: "12px" }}>
        Είναι συνταξιούχοι του Λογαριασμού Ανασφάλιστων Υπερηλίκων του άρθρου 1
        του ν.1296/1982 (ΦΕΚ 128 Α’), όπως ισχύει, ή
      </li>
      <li style={{ fontSize: "1.05rem", marginBottom: "12px" }}>
        Είναι υπάλληλοι ή/και συνταξιούχοι πρώην υπάλληλοι του ΟΠΕΚΑ, με την
        προϋπόθεση ότι καταβάλουν τις προβλεπόμενες εισφορές, ή
      </li>
      <li style={{ fontSize: "1.05rem", marginBottom: "12px" }}>
        Είναι υπάλληλοι του e-ΕΦΚΑ, που μεταφέρθηκαν από τον ΟΓΑ και ήταν
        εγγεγραμμένες/οι στο Μητρώο Δικαιούχων του ΛΑΕ, με την προϋπόθεση ότι
        καταβάλουν τις προβλεπόμενες εισφορές και παραμένουν υπάλληλοι του
        e-ΕΦΚΑ και επιπλέον έχουν τρία ή περισσότερα τέκνα, αντίστοιχα, που και
        αυτά είναι δικαιούχοι των παροχών του ΛΑΕ/ΟΠΕΚΑ (έμμεσα ασφαλισμένα).
      </li>
    </ul>
    <br />
    <p>
      Τα τέκνα που λαμβάνονται υπόψη για τη χορήγηση της παροχής πρέπει να
      πληρούν τις προϋποθέσεις που καταγράφονται πιο κάτω, στους{" "}
      <strong>
        <em>Κανόνες Επιλεξιμότητας Τέκνων.</em>
      </strong>
    </p>
    <p>
      Το ποσό του χρηματικού βοηθήματος – βραβείου ανέρχεται σε 700 ευρώ για τις{" "}
      <strong>τρίτεκνες</strong> και 1.000 ευρώ για τις{" "}
      <strong>πολύτεκνες</strong> μητέρες, ή τους{" "}
      <strong>μονογονείς πατέρες</strong> αντίστοιχα.
    </p>
    <p>
      <strong>
        Κάθε αίτηση που θα υποβληθεί ηλεκτρονικά, επέχει θέση υπεύθυνης
        δήλωσης{" "}
      </strong>{" "}
      του άρθρου 8 του ν. 1599/1986 (ΦΕΚ 75 Α΄) για τα στοιχεία που περιέχονται
      σε αυτήν.
    </p>

    {legalFiles}
  </>
);

export const LoginProgramInfo2025 = ({ legalFiles } = {}) => (
  <>
    <p>
      Ο ΛΑΕ /ΟΠΕΚΑ υλοποιεί και φέτος το{" "}
      <strong>
        <u>Πρόγραμμα 5</u>
      </strong>{" "}
      παροχής χρηματικών βοηθημάτων σε <strong>τρίτεκνες</strong> και{" "}
      <strong> πολύτεκνες μητέρες</strong>, που είναι συνταξιούχοι ή
      ασφαλισμένες του e-ΕΦΚΑ (ΟΓΑ), καθώς και το νέο{" "}
      <strong>
        <u>Πρόγραμμα 6</u>
      </strong>{" "}
      υποτροφίας{" "}
      <strong>
        επιτυχόντων για πρώτη φορά στις Πανελλαδικές Εξετάσεις τέκνων τους.
      </strong>
    </p>

    <p>
      <strong>
        <u>Πρόγραμμα 5: Τρίτεκνες / Πολύτεκνες Μητέρες</u>
      </strong>
      <br />
      Το πρόγραμμα απευθύνεται σε{" "}
      <strong>
        εξακόσιες (600) πολύτεκνες μητέρες και δύο χιλιάδες πεντακόσιες (2.500)
        τρίτεκνες
      </strong>
      . Οι μητέρες πρέπει επίσης να είναι δικαιούχοι περίθαλψης με ενεργή
      ασφαλιστική ικανότητα και ειδικότερα τα τέκνα με δικαίωμα περίθαλψης
      απορρέει από δικαιούχο του ΛΑΕ/ΟΠΕΚΑ.
    </p>
    <p>
      <strong>
        <u>
          Πρόγραμμα 6: Υποτροφίες Επιτυχόντων Τέκνων τους στις Πανελλαδικές
          Εξετάσεις (Νέο Πρόγραμμα){" "}
        </u>
      </strong>
      <br />
      Το πρόγραμμα απευθύνεται σε{" "}
      <strong>
        εξακόσια πενήντα (650) επιτυχόντα για πρώτη φορά στις Πανελλαδικές
        εξετάσεις τέκνα τρίτεκνων και πολύτεκνων μητέρων
      </strong>
      . Οι μητέρες υποβάλλουν τις σχετικές αιτήσεις και θα πρέπει να πληρούν τις
      προϋποθέσεις του (παραπάνω) Προγράμματος 5.
    </p>
    <p>
      <p>
        Σε περίπτωση που εκδηλωθεί ενδιαφέρον από αριθμό δικαιούχων πέραν του
        οριζομένου, ανά κατηγορία ορίου, η επιλογή γίνεται με κλήρωση, η οποία
        διεξάγεται με τη διαδικασία που ορίζεται με απόφαση του Δ.Σ. του ΟΠΕΚΑ.
      </p>
    </p>

    <p>
      <strong>Προϋποθέσεις: </strong>
      Δικαίωμα συμμετοχής στο πρόγραμμα παροχής χρηματικών βοηθημάτων-βραβείων
      σε <strong>τρίτεκνες</strong> και <strong>πολύτεκνες</strong> (μητέρες
      τουλάχιστον τεσσάρων τέκνων) έχουν οι μητέρες που εμπίπτουν στις
      περιπτώσεις:
    </p>
    <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
      <li style={{ fontSize: "1.05rem", marginBottom: "12px" }}>
        Είναι ασφαλισμένες του e-ΕΦΚΑ (ΟΓΑ) και ασφαλιστικά ενήμερες κατά την{" "}
        <strong>31η Δεκεμβρίου 2024</strong>,
      </li>
      <li style={{ fontSize: "1.05rem", marginBottom: "12px" }}>
        Είναι οι συνταξιούχοι του e-ΕΦΚΑ (ΟΓΑ),
      </li>
      <li style={{ fontSize: "1.05rem", marginBottom: "12px" }}>
        Είναι συνταξιούχοι του Λογαριασμού Ανασφάλιστων Υπερηλίκων του άρθρου 1
        του ν.1296/1982 (ΦΕΚ 128 Α’), όπως ισχύει,
      </li>
      <li style={{ fontSize: "1.05rem", marginBottom: "12px" }}>
        Είναι υπάλληλοι ή/και συνταξιούχοι πρώην υπάλληλοι του ΟΠΕΚΑ, με την
        προϋπόθεση ότι καταβάλουν τις προβλεπόμενες εισφορές,
      </li>
      <li style={{ fontSize: "1.05rem", marginBottom: "12px" }}>
        Είναι υπάλληλοι του e-ΕΦΚΑ, που μεταφέρθηκαν από τον ΟΓΑ και ήταν
        εγγεγραμμένες στο Μητρώο Δικαιούχων του ΛΑΕ, με την προϋπόθεση ότι
        καταβάλουν τις προβλεπόμενες εισφορές και παραμένουν υπάλληλοι του
        e-ΕΦΚΑ.
      </li>
    </ul>
    <br />
    <p>
      Το ποσό των χρηματικών βραβείων στις τρίτεκνες και πολύτεκνες μητέρες
      καθορίζεται με απόφαση της Διαχειριστικής Επιτροπής του ΛΑΕ, σύμφωνα με τα
      οριζόμενα στο άρθρο 3 του ν.3050/2002.
    </p>
    <p>
      <strong>
        Κάθε αίτηση που θα υποβληθεί ηλεκτρονικά, επέχει θέση υπεύθυνης
        δήλωσης{" "}
      </strong>{" "}
      του άρθρου 8 του ν. 1599/1986 (ΦΕΚ 75 Α΄) για τα στοιχεία που περιέχονται
      σε αυτήν
    </p>

    {legalFiles}
  </>
);
